var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavouritesSelected(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6096 6.4754C29.8521 5.69063 28.9528 5.06809 27.9629 4.64335C26.9731 4.21861 25.9121 4 24.8406 4C23.7691 4 22.7082 4.21861 21.7183 4.64335C20.7284 5.06809 19.8291 5.69063 19.0716 6.4754L17.4996 8.10333L15.9276 6.4754C14.3976 4.89096 12.3224 4.00082 10.1586 4.00082C7.9948 4.00082 5.91963 4.89096 4.3896 6.4754C2.85956 8.05985 2 10.2088 2 12.4496C2 14.6903 2.85956 16.8393 4.3896 18.4237L5.96161 20.0517L16.0295 30.4776C16.833 31.3096 18.1663 31.3096 18.9697 30.4776L29.0376 20.0517L30.6096 18.4237C31.3674 17.6393 31.9686 16.708 32.3787 15.6829C32.7889 14.6579 33 13.5592 33 12.4496C33 11.34 32.7889 10.2413 32.3787 9.21622C31.9686 8.19115 31.3674 7.25981 30.6096 6.4754Z",
    fill: "#1F347B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesSelected);
export default __webpack_public_path__ + "static/media/favourites-selected.ef3c183064ef9ba8b04dbd1601d19864.svg";
export { ForwardRef as ReactComponent };